/* TTL — gallery video fullscreen button + tap-to-toggle.
 * Single click on the FS button → fullscreen the video element (cross-browser).
 */
(function () {
  if (window.__ttlGalleryVideoBound) return;
  window.__ttlGalleryVideoBound = true;

  function requestFullscreen(el) {
    const fn =
      el.requestFullscreen ||
      el.webkitRequestFullscreen ||      // Safari desktop
      el.webkitEnterFullscreen ||        // iOS Safari (only works on <video>)
      el.mozRequestFullScreen ||
      el.msRequestFullscreen;
    if (fn) fn.call(el);
  }

  function exitFullscreen() {
    const fn =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;
    if (fn) fn.call(document);
  }

  function isFullscreen() {
    return !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );
  }

  function bind(wrap) {
    if (wrap.__ttlGvBound) return;
    wrap.__ttlGvBound = true;
    const btn = wrap.querySelector('.ttl-gallery-video__fs');
    const video = wrap.querySelector('.ttl-gallery-video__el');
    if (!btn || !video) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isFullscreen()) {
        exitFullscreen();
      } else {
        // iOS Safari only supports fullscreen on the video element itself.
        // Other browsers can fullscreen the wrapper (keeps our button visible).
        const target = ('webkitEnterFullscreen' in video) ? video : (wrap.requestFullscreen ? wrap : video);
        requestFullscreen(target);
      }
    });
  }

  function scan() {
    document.querySelectorAll('[data-ttl-gallery-video]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-ttl-gallery-video]')) bind(node);
          if (node.querySelectorAll) node.querySelectorAll('[data-ttl-gallery-video]').forEach(bind);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
